<template>
  <router-link :to="fdDetailsLink">
    <button class="button is-large is-fullwidth is-light"
      :class="[pastFD ? '' : 'is-primary'] ">{{date.toDate().toLocaleDateString()}} - {{sponsor ? sponsor :
      "Apex"}}</button>
  </router-link>
</template>
<script>
export default {
  props: ['id', 'date', 'sponsor', 'pastFD'],
  computed: {
    fdDetailsLink() {
      return this.$route.path + "/" + this.id;
    }
  }
}
</script>
    